// src/pages/DashboardRouter.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import StaffDashboard from './StaffDashboard';

export default function DashboardRouter() {
  const role = localStorage.getItem('role');

  if (role === 'Admin') {
    return <AdminDashboard />;
  } else if (role === 'Staff') {
    return <StaffDashboard />;
  }

  // If no valid role, redirect to login
  return <Navigate to="/login" replace />;
}
